module.exports = __webpack_public_path__ + "static/media/girlImg.94963076.png";